import React, { Component } from "react";
import { mobileModel } from "react-device-detect";
import Reaptcha from "reaptcha";
import PropTypes from 'prop-types';

class MobileModal extends Component {
  render() {
    const {
      modalId = "mobileModal",
      logoSrc = "images/modal-logo.svg",
      closeButtonElement = null,
      phoneNo = "",
      code = "",
      disableField = false,
      onlyAcceptInputs,
      handleInputChange,
      onKeyPressData,
      codeError = "",
      displayResendSMSForMobile,
      displayChangeMobileNumber,
      codeStatus = false,
      resendSuccessMessagDisplay,
      resendErrorMessageDisplay,
      reCaptchaProps = {},
      stylingOfNextButtonPopup,
      disableVerifyOkButton = false,
      handleRecaptchaMobileVerify
    } = this.props;

    return (
      <dialog className="modal fade" id={modalId} tabIndex="-1" aria-labelledby={`${modalId}Label`} aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog">
          <div className="modal-content">
            {closeButtonElement}
            <div className="modal-body">
              <div className="logo">
                <img src={logoSrc} alt="logo" className="img-fluid" />
              </div>
              <h5 className="modal-title" id={`${modalId}Label`}>
                Enter the 6-digit code we have sent to {phoneNo}.
              </h5>
              <input className="form-control" type="text" id="code" name="code" placeholder="Enter code here" value={code} disabled={disableField} onPaste={(event) => { onlyAcceptInputs(event); }} required onChange={(event) => handleInputChange(event)} onKeyPress={(event) => { onKeyPressData(event); }} />
              <p className="text-center modal-error-msg mt-4 mb-4">
                {codeError !== "" && <span style={{ color: "#e60000", fontSize: "0.81rem" }}>{codeError}</span>}
              </p>
              <p className="text-center link--block mb-2">
                {displayResendSMSForMobile()}
                {this.props.showMobileandEmailAddress && displayChangeMobileNumber()}
              </p>
              {codeError === '' && codeStatus && (
                <p id="verifyMessage" className="text-center modal-error-msg mb-0">
                  {resendSuccessMessagDisplay()}
                  {resendErrorMessageDisplay()}
                </p>
              )}
            </div>
            {reCaptchaProps.render && (
              <Reaptcha ref={reCaptchaProps.refCallback} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} size={"invisible"} onLoad={reCaptchaProps.onLoad} onVerify={reCaptchaProps.onVerify} />
            )}
            <div className="modal-footer pb-0 pl-0">
              <button type="submit" id="moible-redirect-screen" className={stylingOfNextButtonPopup()} disabled={disableVerifyOkButton} onClick={(e) => handleRecaptchaMobileVerify(e)}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </dialog>
    );
  }
}
MobileModal.propTypes = {
  modalId: PropTypes.string,
  logoSrc: PropTypes.string,
  closeButtonElement: PropTypes.any,
  phoneNo: PropTypes.string,
  code: PropTypes.any,
  disableField: PropTypes.bool,
  onlyAcceptInputs: PropTypes.func,
  handleInputChange: PropTypes.func,
  onKeyPressData: PropTypes.func,
  codeError: PropTypes.string,
  displayResendSMSForMobile: PropTypes.func,
  displayChangeMobileNumber: PropTypes.func,
  codeStatus: PropTypes.bool,
  resendSuccessMessagDisplay: PropTypes.func,
  resendErrorMessageDisplay: PropTypes.func,
  reCaptchaProps: PropTypes.any,
  stylingOfNextButtonPopup: PropTypes.func,
  disableVerifyOkButton: PropTypes.bool,
  handleRecaptchaMobileVerify: PropTypes.func,
  showMobileandEmailAddress: PropTypes.bool
}
export default MobileModal;